export default __webpack_public_path__ + "static/media/landing.25a50762.jpg";